import { SiteLayout } from "./home/SiteLayout";
import { PageHero } from "./home/components/PageHero";
import { FaqSection } from "./home/sections/FaqSection";
import { RichText, useSiteTranslation } from "./home/i18n";

export default function FAQComponent() {
  const { t } = useSiteTranslation();

  return (
    <SiteLayout title={t("faqPage.title")}>
      <PageHero eyebrow={t("faqPage.eyebrow")} title={<RichText k="faqPage.heading" />} lead={t("faqPage.lead")} />
      <FaqSection
        items={t("help.faqs", { returnObjects: true })}
        id="questions"
        eyebrow={t("faqPage.listEyebrow")}
        title={t("faqPage.listTitle")}
        lead={t("faqPage.listLead")}
      />
    </SiteLayout>
  );
}
